<div class="image-container" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()">
  <h3 *ngIf="!imageUrl && !loading">Waiting for image...</h3>
  <h3 *ngIf="imageUrl && loading">Loading...</h3>
  <div>
    <img *ngIf="imageUrl" #imageElement [src]="imageUrl" />
    <div *ngFor="let detectedObject of detectedObjects" class="bounding-box"
      [style.left.%]="detectedObject.box.topX * 100" [style.top.%]="detectedObject.box.topY * 100"
      [style.width.%]="(detectedObject.box.bottomX - detectedObject.box.topX) * 100"
      [style.height.%]="(detectedObject.box.bottomY - detectedObject.box.topY) * 100"
      (mousedown)="onMouseDown($event, detectedObject)">
      <span class="label">
        {{ detectedObject.label }} ({{ (detectedObject.score * 100) | number: '1.0-2' }}%)
      </span>
    </div>
  </div>
  <div>
    <button *ngIf="changed" (click)="save()">Save changes</button>
  </div>
</div>